import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { LoggerService } from '../../../services/logger/logger.service';
import { Schedule } from '../models/schedule';
import { ScheduleService } from './schedule.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

@Injectable()
export class ScheduleStateService {

  private _allSchedules: Schedule[];

  constructor(
    private logger: LoggerService,
    private scheduleService: ScheduleService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  get allSchedules(): Schedule[] {
    return this._allSchedules;
  }

  initialize(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {

        this.logger.info('ScheduleStateService: initialize.');

        if (!this._allSchedules) {

          this.logger.info('ScheduleStateService: initialize receiving all schedules info.');

          this.scheduleService.getAllSchedulesInfo().subscribe(
            result => {
              this.logger.info('ScheduleStateService: initialize all schedules info received.');
              this._allSchedules = result ? result : null;
              observable.next(true);
            },
            error => {
              this.logger.info(`ScheduleStateService: initialize all schedules info receive error ${error}.`);
              observable.error(error);
            },
            () => {
              // observable.complete();
            }
          );
        } else {
          observable.next(true);
        }
      }
    );
  }

  get schedulePlanTitle(): string {
    if (
      this.shopSettingsService &&
      this.shopSettingsService.shopSettings &&
      this.shopSettingsService.shopSettings.schedulePlanTitle) {
      return this.shopSettingsService.shopSettings.schedulePlanTitle;
    }

    return 'Opening Hours';
  }

  get schedulePlanDescription(): string {
    if (
      this.shopSettingsService &&
      this.shopSettingsService.shopSettings &&
      this.shopSettingsService.shopSettings.schedulePlanDescription) {
      return this.shopSettingsService.shopSettings.schedulePlanDescription;
    }

    return '';
  }
}
